export const formatCurrency = (n, currency = "INR") => {
    const num = Number(n || 0);
    try {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency,
            maximumFractionDigits: 0,
        }).format(num);
    } catch {
        return `₹${num.toLocaleString("en-IN")}`;
    }
};

export const formatDate = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch {
        return String(iso);
    }
};

export const formatDateTime = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return (
            d.toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            }) +
            " · " +
            d.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
            })
        );
    } catch {
        return String(iso);
    }
};

export const ORDER_STATUS_META = {
    pending: { label: "Pending", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
    in_progress: { label: "In Progress", color: "bg-blue-500/15 text-blue-300 border-blue-500/30" },
    given: { label: "Given", color: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
    completed: { label: "Completed", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
    delivered: { label: "Delivered", color: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
    remaining: { label: "Remaining", color: "bg-orange-500/15 text-orange-300 border-orange-500/30" },
    cancelled: { label: "Cancelled", color: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
};

export const PAYMENT_STATUS_META = {
    unpaid: { label: "Unpaid", color: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
    partial: { label: "Partial", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
    paid: { label: "Paid", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
    overdue: { label: "Overdue", color: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
};
